import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm$actionsStore$sele, _vm$actionsStore$sele2, _vm$actionsStore$sele3, _vm$actionsStore$sele4;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'text',
        label: 'Fornecedor',
        field: 'fornecedor'
      }, {
        type: 'date',
        label: 'Data Solicitação',
        field: 'data_solicitacao'
      }, {
        type: 'date',
        label: 'Criação',
        field: 'created_at'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Em Aberto', 'Em Andamento', 'Cancelado', 'Atendida', 'Encaminhada']
      }]
    }
  }), _vm.actionsStore.selectedRows.length > 0 ? _c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: 'Mais ações',
      expression: "'Mais ações'",
      modifiers: {
        "right": true
      }
    }],
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "50px"
    },
    attrs: {
      "id": "menu",
      "variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('Menu', {
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }], null, false, 2976318409)
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.atualizarStatus",
      modifiers: {
        "atualizarStatus": true
      }
    }]
  }, [_vm._v(" Atualizar Status ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.duplicarOrdem",
      modifiers: {
        "duplicarOrdem": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1
    }
  }, [_vm._v(" Duplicar Ordem Compra ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.gerarFinanceiroOrdem",
      modifiers: {
        "gerarFinanceiroOrdem": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1 || _vm.isFinanceiroBloqueado(_vm.actionsStore.selectedRows[0])
    }
  }, [_vm._v(" Gerar Financeiro ")])], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "duplicarOrdem",
      "title": "Deseja duplicar o Ordem selecionada?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          ref: "doubleOrdem",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.duplicar
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_vm._v("Pedido a ser duplicado "), _c('p', [_vm._v("Número: " + _vm._s((_vm$actionsStore$sele = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele === void 0 ? void 0 : _vm$actionsStore$sele.numero))])])]), _c('b-modal', {
    attrs: {
      "id": "faturarPedido",
      "title": "Deseja faturar o Pedido?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('div', [_c('b-button', {
          ref: "faturarPedido",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary",
            "disabled": _vm.permitido_faturar
          },
          on: {
            "click": _vm.faturarPedido
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_c('p', [_c('strong', [_vm._v("Pedido a ser faturado número: " + _vm._s((_vm$actionsStore$sele2 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele2 === void 0 ? void 0 : _vm$actionsStore$sele2.numero) + " ")])]), (_vm$actionsStore$sele3 = _vm.actionsStore.selectedRows[0]) !== null && _vm$actionsStore$sele3 !== void 0 && _vm$actionsStore$sele3.pagamentos ? _c('p', [_vm._v(" Forma Pagamento: " + _vm._s(_vm.formataPagamento((_vm$actionsStore$sele4 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele4 === void 0 ? void 0 : _vm$actionsStore$sele4.pagamentos)) + " ")]) : _vm._e()]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v("Movimentar estoque")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.movimentar_estoque,
      expression: "movimentar_estoque"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.movimentar_estoque) ? _vm._i(_vm.movimentar_estoque, null) > -1 : _vm.movimentar_estoque
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.movimentar_estoque,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.movimentar_estoque = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.movimentar_estoque = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.movimentar_estoque = $$c;
        }
      }
    }
  }), _c('span')])])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v("Gerar financeiro")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.gerar_financeiro,
      expression: "gerar_financeiro"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gerar_financeiro) ? _vm._i(_vm.gerar_financeiro, null) > -1 : _vm.gerar_financeiro
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.gerar_financeiro,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gerar_financeiro = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.gerar_financeiro = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.gerar_financeiro = $$c;
        }
      }
    }
  }), _c('span')])])]), _c('b-col', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_faturamento",
      "label-for": "data_faturamento",
      "label": "Data do Faturamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "required": ""
    },
    model: {
      value: _vm.data_faturamento,
      callback: function callback($$v) {
        _vm.data_faturamento = $$v;
      },
      expression: "data_faturamento"
    }
  })], 1)], 1)], 1)], 1), _c('TableApp', {
    ref: "ordemList",
    attrs: {
      "titulo": "Ordem de Compra",
      "acaoBtn": "/#/ordem-compra-nova",
      "textoBtn": "Nova Ordem",
      "api-url": "/ordemcompra/lista",
      "fields": _vm.fields,
      "classFilterColumn": "numero",
      "perPage": 10,
      "multiselect": true
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "numero"
          },
          slot: "numero"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.numero) + " ")])])]) : _vm._e(), props.field == 'fornecedor' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "fornecedor"
          },
          slot: "fornecedor"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.fornecedor) + " ")])])]) : _vm._e(), props.field == 'status' ? _c('span', {
          staticClass: "status-cell",
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [_c('span', {
          class: _vm.statusOrdemCompraClass(props.rowData.status)
        }, [_vm._v(" " + _vm._s(_vm.statusOrdemCompraLabel(props.rowData.status)) + " ")]), props.rowData.financeiro_gerado ? _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            value: 'Financeiro gerado',
            expression: "'Financeiro gerado'",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "financeiro-badge"
        }, [_vm._v(" F ")]) : _vm._e()]) : _vm._e(), props.field == 'data_solicitacao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "data_solicitacao"
          },
          slot: "data_solicitacao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center justify-content-end font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.data_solicitacao, "DD/MM/YYYY")) + " ")])]) : _vm._e(), props.field == 'created_at' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "created_at"
          },
          slot: "created_at"
        }, [_c('div', {
          staticClass: "d-flex align-items-center justify-content-end font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.created_at, "DD/MM/YYYY")) + " ")])]) : _vm._e(), props.field == 'valorTotal' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "valorTotal"
          },
          slot: "valorTotal"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.valorTotal, 2)) + " ")]) : _vm._e(), props.field == 'actions' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.righttop",
            value: 'Imprimir Ordem',
            expression: "'Imprimir Ordem'",
            modifiers: {
              "righttop": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.imprimirOrdem(props.rowData);
            }
          }
        }, [_c('PdfIcon', {
          attrs: {
            "size": 22
          }
        })], 1), props.rowData.status !== 4 && props.rowData.status !== 3 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.righttop",
            value: 'Editar Ordem',
            expression: "'Editar Ordem'",
            modifiers: {
              "righttop": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.editarOrdem(props.rowData);
            }
          }
        }, [_c('PencilIcon', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.righttop",
            value: 'Encaminhar PDF para o whatsapp do fornecedor',
            expression: "\n              'Encaminhar PDF para o whatsapp do fornecedor'\n            ",
            modifiers: {
              "righttop": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.shareToWhatsapp(props.rowData);
            }
          }
        }, [_c('Whatsapp', {
          attrs: {
            "size": 20
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Copiar Link',
            expression: "'Copiar Link'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          attrs: {
            "placement": "bottom"
          },
          on: {
            "click": function click($event) {
              return _vm.doCopy(props.rowData, props.rowData.id_ordem_compra);
            }
          }
        }, [_c('Link', {
          attrs: {
            "size": 16
          }
        })], 1), props.rowData.status == 1 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Excluir Ordem',
            expression: "'Excluir Ordem'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e()])]) : _vm._e()];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "atualizarStatus",
      "title": "Atualizar status",
      "size": "md",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var ok = _ref3.ok,
          cancel = _ref3.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "enviar_correcao",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarStatus
          }
        }, [_vm._v(" Salvar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: _vm.statusToUpdate,
      callback: function callback($$v) {
        _vm.statusToUpdate = $$v;
      },
      expression: "statusToUpdate"
    }
  }, _vm._l(_vm.ordemStatus, function (status) {
    return _c('b-form-select-option', {
      key: status.id,
      attrs: {
        "value": status.id
      }
    }, [_vm._v(" " + _vm._s(status.descricao) + " ")]);
  }), 1)], 1)], 1)], 1)], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "gerarFinanceiroOrdem",
      "title": "Gerar Financeiro",
      "size": "lg",
      "centered": "",
      "scrollable": ""
    },
    on: {
      "show": _vm.abrirModalFinanceiro
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref4) {
        var cancel = _ref4.cancel;
        return [_c('div', [_c('b-button', {
          ref: "btnGerarFinanceiro",
          staticClass: "mr-2",
          attrs: {
            "variant": "primary",
            "disabled": _vm.loadingFaturamento || !_vm.faturamentoData
          },
          on: {
            "click": _vm.confirmarGerarFinanceiro
          }
        }, [_vm._v(" Gerar Financeiro ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_vm.loadingFaturamento ? _c('div', {
    staticClass: "text-center py-5"
  }, [_c('b-spinner', {
    attrs: {
      "label": "Carregando..."
    }
  })], 1) : _vm.faturamentoData ? _c('div', [_c('b-alert', {
    staticClass: "mb-3",
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v(" Confira as informações do faturamento abaixo. Caso necessário, altere os valores e vencimentos antes de gerar o financeiro. Ao confirmar, será gerado o contas a pagar vinculado a esta ordem de compra. ")]), _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Ordem de Compra:")]), _vm._v(" " + _vm._s(_vm.faturamentoData.numero) + " ")]), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Valor Total:")]), _vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.faturamentoData.valorTotal, 2)) + " ")])], 1), _c('hr'), _vm._l(_vm.faturamentoData.pagamentos, function (pagamento, index) {
    var _pagamento$paymentMod;
    return _c('div', {
      key: index,
      staticClass: "mb-4"
    }, [_c('h6', {
      staticClass: "text-dark"
    }, [_vm._v(" " + _vm._s(pagamento.descricao || ((_pagamento$paymentMod = pagamento.paymentMode) === null || _pagamento$paymentMod === void 0 ? void 0 : _pagamento$paymentMod.description)) + " ")]), _c('b-table', {
      staticClass: "mb-0",
      attrs: {
        "items": pagamento.range,
        "fields": _vm.parcelaFields,
        "small": "",
        "responsive": ""
      },
      scopedSlots: _vm._u([{
        key: "cell(parcela)",
        fn: function fn(row) {
          return [_vm._v(" " + _vm._s(row.index + 1) + " ")];
        }
      }, {
        key: "cell(value)",
        fn: function fn(row) {
          return [_c('b-input-group', {
            attrs: {
              "prepend": "R$",
              "size": "sm"
            }
          }, [_c('b-form-input', {
            attrs: {
              "type": "number",
              "step": "0.01",
              "size": "sm"
            },
            on: {
              "change": _vm.recalcularValorTotal
            },
            model: {
              value: pagamento.range[row.index].value,
              callback: function callback($$v) {
                _vm.$set(pagamento.range[row.index], "value", _vm._n($$v));
              },
              expression: "pagamento.range[row.index].value"
            }
          })], 1)];
        }
      }, {
        key: "cell(date)",
        fn: function fn(row) {
          return [_c('b-form-input', {
            attrs: {
              "type": "date",
              "size": "sm"
            },
            model: {
              value: pagamento.range[row.index].date,
              callback: function callback($$v) {
                _vm.$set(pagamento.range[row.index], "date", $$v);
              },
              expression: "pagamento.range[row.index].date"
            }
          })];
        }
      }], null, true)
    })], 1);
  })], 2) : _c('div', {
    staticClass: "text-center py-5 text-muted"
  }, [_vm._v(" Não há faturamento disponível para esta ordem de compra. ")])]), _c('SendToWppModal', {
    attrs: {
      "data": _vm.dataToWhatsapp,
      "openModal": _vm.wppOpenModal,
      "module": "ordemCompra"
    },
    on: {
      "handleOpenModal": function handleOpenModal(openModal) {
        return _vm.wppOpenModal = openModal;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };